import {
  DIGITAL_PRODUCT_LISTING_TYPES,
  GROUP_SESSION_LISTING_TYPES,
  INDIVIDUAL_SESSION_LISTING_TYPES,
} from '../../util/soulwise-marketplace/listingType';

export const SEARCH_FIELDS = {
  VENUE_SEARCH_FIELD: 'pub_venueName',
  MODE_SEARCH_FIELD: 'pub_mode',
  LISTINGTYPE_SEARCH_FIELD: 'pub_listingType',
  CATEGORYLEVEL1_SEARCH_FIELD: 'pub_categoryLevel1',
  CATEGORYLEVEL2_SEARCH_FIELD: 'pub_categoryLevel2',
  DATES_SEARCH_FIELD: 'dates',
};

export const GROUP_SESSION_LISTING_TYPES_AS_SEARCH_QUERY = GROUP_SESSION_LISTING_TYPES.join(',');
export const INDIVIDUAL_SESSION_LISTING_TYPES_AS_SEARCH_QUERY = INDIVIDUAL_SESSION_LISTING_TYPES.join(
  ','
);
export const DIGITAL_PRODUCT_LISTING_TYPES_AS_SEARCH_QUERY = DIGITAL_PRODUCT_LISTING_TYPES.join(
  ','
);

/** Form-only key for the Content filter chip (commas in RHF field paths break toggling). */
export const CONTENT_LISTING_TYPE_FILTER_KEY = 'digital-content';
